const shouldLoad = ({ data, loading, error }) => !data && !loading && !error;
export default shouldLoad;
